import React, { useContext } from "react";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const columns = [
  { field: "id", header: "ID", width: "8rem" },
  { field: "nombre", header: "Nombre" },
  { field: "domicilio", header: "Domicilio" },
  { field: "telefono", header: "Teléfono" },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "10rem" },
];

const fields = [
  { name: "nombre", label: "Nombre", type: "text", required: true, md: 12 },
  { name: "domicilio", label: "Domicilio", type: "text", md: 8 },
  { name: "telefono", label: "Teléfono", type: "text", md: 4 },
  { name: "habilitado", label: "Habilitado", type: "switch" },
];

export default function Bases() {
  const { bases, obtenerBases, agregarBase, actualizarBase } =
    useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Bases Operativas"
      entidad="base"
      layout="Bases"
      icono={<BusinessOutlinedIcon />}
      items={bases}
      columns={columns}
      fields={fields}
      nuevoDefault={{ nombre: "", domicilio: "", telefono: "", habilitado: true }}
      onObtener={() => obtenerBases({ todos: true })}
      onAgregar={(data) => agregarBase({ base: data })}
      onActualizar={(data) => actualizarBase({ base: data })}
    />
  );
}
